import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("img", {
    id: "logo",
    src: require(`@/app/ui/assets/images/logo-sub-console.png`),
    class: "hidden",
    alt: "logo"
  }, null, 8, ["src"]))
}